import { FC, useEffect, useState } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography } from '@altermaind/web/ui';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';
import { CallResponseGetAspectColors } from '@/aspect/state/api/getAspectColorsCall';

type Props = {
  responseGetAspectColors: CallResponseGetAspectColors;
  onSelectedNewColor: (color: string) => void;
  colorSuggested?: string;
};

export const ColorsList: FC<Props> = ({
  responseGetAspectColors,
  onSelectedNewColor,
  colorSuggested,
}) => {
  const t = useTranslations('settings.tabs.aspect');
  const { genericResponsiveValue } = useResponsiveStyle();

  const [internalColor, setInternalColor] = useState<string>();

  useEffect(() => {
    if (responseGetAspectColors && colorSuggested?.slice(0, 4) === 'rgba') {
      setInternalColor(
        responseGetAspectColors.colors.find(
          color => color.dark === colorSuggested || color.light === colorSuggested,
        )?.id,
      );
    } else {
      setInternalColor(colorSuggested);
    }
  }, [colorSuggested, internalColor, responseGetAspectColors]);

  return (
    <>
      <Typography variant='h4' mb='s'>
        {t('titleColor')}
      </Typography>
      <Box
        mb='m'
        display='flex'
        flexWrap={genericResponsiveValue({
          breakPoints: { desktop: 'no-wrap' },
          defaultValue: 'wrap',
        })}
      >
        {responseGetAspectColors &&
          responseGetAspectColors.colors.map(color => (
            <Box
              mr='s'
              mb='s'
              borderRadius='xl'
              p='xxxs'
              border={internalColor === color.id ? '1px solid white' : '1px solid transparent'}
              display='flex'
              alignItems='center'
              justifyContent='center'
              key={color.id}
              style={{
                cursor: 'pointer',
                transition: 'border 0.2s',
                width: genericResponsiveValue({
                  breakPoints: { desktop: 'none' },
                  defaultValue: '20%',
                }),
                maxWidth: '44px',
                boxSizing: 'border-box',
              }}
              onClick={() => onSelectedNewColor(color.id)}
            >
              <Box
                borderRadius='xl'
                width='m'
                height='m'
                style={{
                  backgroundColor: color.dark,
                }}
              />
            </Box>
          ))}
      </Box>
    </>
  );
};
